import { dealershipDto } from "../dtos/dealershipDto";
import { Dealership } from "../models/dealership";
import ApiService from "../services/api";

export const fetchFavoritesDealerships = async (): Promise<Dealership[]> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/dealerships/favorites`);
        if (response.status === 200) {
            return response.data.map(dealershipDto);
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const fetchDealershipsByGeolocation = async (lat: number, lng: number): Promise<Dealership[]> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/dealerships/geo?latitude=${lat}&longitude=${lng}&maxDistance=1000&limit=5`);
        if (response.status === 200) {
            return response.data.map(dealershipDto);
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const fetchDealershipsByStateAndCity = async (state: string, city: string): Promise<Dealership[]> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/dealerships?state=${state}&city=${city}&name=`);
        if (response.status === 200) {
            return response.data.map(dealershipDto);
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const fetchDealershipsByDN = async (dn: string): Promise<Dealership | null> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/dealerships/dn/${dn}`);
        if (response.status === 200) {
            return dealershipDto(response.data);
        } else return null;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const fetchDealerships = async (name?: string, dn?: string): Promise<Dealership[]> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/dealerships?name=${name}&dn=${dn}&city=&state=`);
        if (response.status === 200) {
            return response.data.map(dealershipDto);
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const fetchGroupConsultantDealershipsByGeolocation = async (lat: number, lng: number): Promise<Dealership[]> => {
    const apiService = new ApiService();

    try {
        const response = await apiService.get<any>(`/dealerships/geo/consultant-group?latitude=${lat}&longitude=${lng}&maxDistance=1000`);
        if (response.status === 200) {
            return response.data.map(dealershipDto);
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const fetchGroupConsultantDealershipsByStateAndCity = async (state: string, city: string, name?: string): Promise<Dealership[]> => {
    const apiService = new ApiService();

    try {
        const response = await apiService.get<any>(`/dealerships/consultant-group?city=&state=&name=${name ?? ''}`);
        if (response.status === 200) {
            return response.data.map(dealershipDto);
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

export const fetchDealershipsDnGroup = async (dn?: string): Promise<null | {groupId: string, id: string, fantasyName: string}> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/dealerships/dn/${dn}`);
        if (response.status === 200) {
            return response.data;
        } else return null;
    } catch (error) {
        console.error(error);
        return null;
    }
}